const API_BASE = process.env.REACT_APP_API_URL || "http://127.0.0.1:4998";

async function getAuthHeaders(includeJson = false) {
  const { supabase } = await import("../../supabase");
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) {
    throw new Error("No active session");
  }
  const headers = { Authorization: `Bearer ${session.access_token}` };
  if (includeJson) {
    headers["Content-Type"] = "application/json";
  }
  return headers;
}

export async function createShareLink(resourceType, resourceId) {
  const headers = await getAuthHeaders(true);
  const response = await fetch(`${API_BASE}/api/share-links`, {
    method: "POST",
    headers,
    body: JSON.stringify({
      resource_type: resourceType,
      resource_id: resourceId
    })
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Failed to create share link");
  }
  return data.share_id;
}

export async function fetchShareLinks() {
  const headers = await getAuthHeaders();
  const response = await fetch(`${API_BASE}/api/share-links`, {
    method: "GET",
    headers
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Failed to load share links");
  }
  return data.share_links || [];
}

export async function fetchShareLink(shareId) {
  const response = await fetch(`${API_BASE}/api/share-links/${shareId}`);
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Failed to load shared results");
  }
  return data.share;
}

export async function deleteShareLink(shareId) {
  const headers = await getAuthHeaders();
  const response = await fetch(`${API_BASE}/api/share-links/${shareId}`, {
    method: "DELETE",
    headers
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Failed to delete share link");
  }
  return data;
}
